import { AbstractControl, ValidationErrors } from "@angular/forms";

export const passwordValidator = (control: AbstractControl): ValidationErrors | null => {
  const value = control.value as string;
  if (!value) {
    return null;
  }
  const hasUpperCase = /[A-Z]/.test(value);
  const hasLowerCase = /[a-z]/.test(value);
  const hasNumber = /\d/.test(value);
  const hasSpecialChar = /\W/.test(value);
  const validLength = value.length >= 8 && value.length <= 64;

  const errors = {};
  if (!validLength) {
    errors["lengthInvalid"] = true;
  }
  if ([hasUpperCase, hasLowerCase, hasNumber, hasSpecialChar].filter(Boolean).length < 3) {
    if (!hasUpperCase) {
      errors["missingUpperCase"] = true;
    }
    if (!hasLowerCase) {
      errors["missingLowerCase"] = true;
    }
    if (!hasNumber) {
      errors["missingNumber"] = true;
    }
    if (!hasSpecialChar) {
      errors["missingSpecialChar"] = true;
    }
  }
  return Object.keys(errors).length ? errors : null;
};
